import { Box, Typography, Skeleton } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { workProfileSectionTitleSx } from '../../constants/workProfileSectionTitle';

const EsProfileMyProjectsGridLoadingState = () => {
    const { themeStyle } = useThemeContext();

    return (
        <Box
            style={{
                width: '100%',
                height: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'center',
                gap: '22px',
                backgroundColor: theme[themeStyle].gray_text,
                borderRadius: '10px',
                padding: '30px',
            }}>
            <Typography sx={workProfileSectionTitleSx(themeStyle)}>My Projects</Typography>
            <Box sx={{ display: 'block', width: '100%' }}>
                <Skeleton
                    variant="rounded"
                    sx={{
                        fontSize: '1rem',
                        backgroundColor: theme[themeStyle].darkGray60,
                        width: '100%',
                        height: 300,
                        marginBottom: 2,
                    }}
                />
                <Skeleton
                    variant="text"
                    sx={{ fontSize: '1rem', backgroundColor: theme[themeStyle].darkGray60, width: '100%' }}
                />
                <Skeleton
                    variant="text"
                    sx={{ fontSize: '1rem', backgroundColor: theme[themeStyle].darkGray60, width: '90%' }}
                />
                <Skeleton
                    variant="text"
                    sx={{ fontSize: '1rem', backgroundColor: theme[themeStyle].darkGray60, width: '40%' }}
                />
            </Box>
        </Box>
    );
};

export { EsProfileMyProjectsGridLoadingState };
